export default __webpack_public_path__ + "./image/4404ae8b9b5cc06e90773836bdb2294b.png";